import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { TopBanner } from './components/TopBanner';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Services } from './pages/Services';
import { Contact } from './pages/Contact';
import { HelpfulInfo } from './pages/HelpfulInfo';
import { ScreenPrinting } from './pages/services/ScreenPrinting';
import { Embroidery } from './pages/services/Embroidery';
import { DirectToGarment } from './pages/services/DirectToGarment';
import { DirectToFilm } from './pages/services/DirectToFilm';
import { LaserEmbroidery } from './pages/services/LaserEmbroidery';
import { LaserEtching } from './pages/services/LaserEtching';
import { GraphicDesign } from './pages/services/GraphicDesign';
import { HeatTransfer } from './pages/services/HeatTransfer';
import { PromotionalProducts } from './pages/services/PromotionalProducts';
import { PersonalizedProducts } from './pages/services/PersonalizedProducts';
import { LaserEngraving } from './pages/services/LaserEngraving';
import { Banners } from './pages/services/Banners';
import { BusinessCards } from './pages/services/BusinessCards';
import { YardSigns } from './pages/services/YardSigns';
import { VehicleDecals } from './pages/services/VehicleDecals';
import { VehicleMagnets } from './pages/services/VehicleMagnets';
import { Decals } from './pages/services/Decals';
import { FAQs } from './pages/helpful-info/FAQs';
import { Compliance } from './pages/helpful-info/Compliance';
import { ScreenPrintingAdvice } from './pages/helpful-info/ScreenPrintingAdvice';
import { VectorArt } from './pages/helpful-info/VectorArt';
import { WearHausWay } from './pages/helpful-info/WearHausWay';
import { TermsAndConditions } from './pages/helpful-info/TermsAndConditions';
import { PrivacyPolicy } from './pages/helpful-info/PrivacyPolicy';
import { ProductCatalogs } from './pages/products/ProductCatalogs';
import { CampDesigns } from './pages/products/CampDesigns';
import { MonthlySpecial } from './pages/products/MonthlySpecial';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function App() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 flex flex-col" data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <TopBanner data-id="element-2" />
      <Header data-id="element-3" />
      <main className="flex-grow" data-id="element-4">
        <Routes data-id="element-5">
          <Route path="/" element={<Home data-id="element-7" />} data-id="element-6" />
          <Route path="/About-Us" element={<About data-id="element-9" />} data-id="element-8" />
          <Route path="/services" element={<Services data-id="element-11" />} data-id="element-10" />
          <Route path="/Contact" element={<Contact data-id="element-13" />} data-id="element-12" />
          <Route path="/helpful-info" element={<HelpfulInfo data-id="element-15" />} data-id="element-14" />
          <Route path="/Screen-Printing" element={<ScreenPrinting data-id="element-17" />} data-id="element-16" />
          <Route path="/Embroidery-Options" element={<Embroidery data-id="element-19" />} data-id="element-18" />
          <Route path="/Direct-to-Garment" element={<DirectToGarment data-id="element-21" />} data-id="element-20" />
          <Route path="/Direct-to-Film" element={<DirectToFilm data-id="element-23" />} data-id="element-22" />
          <Route path="/Laser-Embroidery" element={<LaserEmbroidery data-id="element-25" />} data-id="element-24" />
          <Route path="/Laser-Etching" element={<LaserEtching data-id="element-27" />} data-id="element-26" />
          <Route path="/Graphic-Design" element={<GraphicDesign data-id="element-29" />} data-id="element-28" />
          <Route path="/Heat-Transfer" element={<HeatTransfer data-id="element-31" />} data-id="element-30" />
          <Route path="/services/promotional-products" element={<PromotionalProducts data-id="element-33" />} data-id="element-32" />
          <Route path="/Personalized-Products" element={<PersonalizedProducts data-id="element-35" />} data-id="element-34" />
          <Route path="/Laser-Cutting-Engraving" element={<LaserEngraving data-id="element-37" />} data-id="element-36" />
          <Route path="/Banners" element={<Banners data-id="element-39" />} data-id="element-38" />
          <Route path="/Business-Cards-Product-Labels" element={<BusinessCards data-id="element-41" />} data-id="element-40" />
          <Route path="/Yard-Signs" element={<YardSigns data-id="element-43" />} data-id="element-42" />
          <Route path="/Vehicle-Wall-and-Windows" element={<VehicleDecals data-id="element-45" />} data-id="element-44" />
          <Route path="/Vehicle-Magnets-Business-Advertising" element={<VehicleMagnets data-id="element-47" />} data-id="element-46" />
          <Route path="/Custom-Decals" element={<Decals data-id="element-49" />} data-id="element-48" />
          <Route path="/12.html" element={<FAQs data-id="element-51" />} data-id="element-50" />
          <Route path="/Compliance" element={<Compliance data-id="element-53" />} data-id="element-52" />
          <Route path="/Screen-Printing-Advice" element={<ScreenPrintingAdvice data-id="element-55" />} data-id="element-54" />
          <Route path="/What-is-Vector-Art" element={<VectorArt data-id="element-57" />} data-id="element-56" />
          <Route path="/The-Wear-Haus-Way" element={<WearHausWay data-id="element-59" />} data-id="element-58" />
          <Route path="/Terms" element={<TermsAndConditions data-id="element-61" />} data-id="element-60" />
          <Route path="/Privacy" element={<PrivacyPolicy data-id="element-63" />} data-id="element-62" />
          <Route path="/ProductCatalogs.html" element={<ProductCatalogs data-id="element-65" />} data-id="element-64" />
          <Route path="/Camp-Designs" element={<CampDesigns data-id="element-67" />} data-id="element-66" />
          <Route path="/Monthly-Special" element={<MonthlySpecial data-id="element-69" />} data-id="element-68" />
        </Routes>
      </main>
      <Footer data-id="element-70" />
    </div>;
}